import { CellphoneLockIcon } from './CellphoneLockIcon';

/**
 * author: Google
 * id 2261E999-4B3A-4540-BB30-B4C130137916
 * name cellphone-lock
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-lock.svg
 * tags
 * - Cellphone / Phone 
 * - Lock 
 * - Device / Tech 
 */
export const PhonelinkLockIcon = CellphoneLockIcon;
export default PhonelinkLockIcon